import { ReactElement, ReactNode, Suspense } from 'react';
import { selectOpenSubMenu } from '../../../../modules/ui/store/ui-slice';
import Alert from '../../../../shared/components/alert/alert';
import PageSpinner from '../../../../shared/components/page-spinner/page-spinner';
import { useBreakpoint } from '../../../../shared/hooks/use-breakpoint';
import { useAppSelector } from '../../../../store/hooks';
import useMenuItems from '../../hooks/use-menu-items';
import Header from '../header/header';
import SideDrawer from '../side-drawer/side-drawer';
import SubMenu from '../submenu/submenu';
import styles from './layout-inner.module.css';

interface Props {
  headerActionButton?: ReactElement;
  children: ReactNode;
  alertId?: string;
}

const LayoutInner = ({ headerActionButton, children, alertId }: Props): JSX.Element => {
  const [, activeMenuItem] = useMenuItems();
  const screens = useBreakpoint();
  const openSubMenu = useAppSelector(selectOpenSubMenu);

  return (
    <>
      <Header actionButton={headerActionButton} />
      {alertId && <Alert alertId={alertId} style={{ margin: '0 18px' }} />}
      <div className={styles.container}>
        {activeMenuItem?.subMenuContent && screens.xl && (
          <SubMenu openSubmenu={openSubMenu} submenuContent={activeMenuItem?.subMenuContent} />
        )}
        {!screens.xl && <SideDrawer submenuContent={activeMenuItem?.subMenuContent} />}
        <div className={styles.children}>
          <Suspense fallback={<PageSpinner />}>{children}</Suspense>
        </div>
      </div>
    </>
  );
};

export default LayoutInner;
